export default __webpack_public_path__ + "static/media/gallery_02.3ec61ca2.jpg";